<script setup lang="ts">
import { bemBuilder, debounce } from "@chatfood/core-utils";
import { ref, watch } from "vue";
import { AtomInput, SatFormControl } from "@chatfood/design-system";
import type { BasketEventNameProps } from "./props";
import { useLocale } from "~/composables/use-locale";
import { useBasketStore } from "~/stores/basket";

const props = withDefaults(defineProps<BasketEventNameProps>(), {
  autoSave: false,
});

const emits = defineEmits<{ update: [value: string] }>();

const css = bemBuilder("basket-event-name");

const { t } = useLocale();

const basketStore = useBasketStore();

const eventName = ref(basketStore.eventName || "");

const debouncedSetMeta = debounce(() => {
  basketStore.setMeta({ eventName: eventName.value });
}, 500);

watch(
  () => eventName.value,
  (newValue, oldValue) => {
    if (newValue === oldValue) return;

    emits("update", newValue);

    if (!props.autoSave) return;

    debouncedSetMeta();
  },
);
</script>

<template>
  <div :class="css('')">
    <SatFormControl :label="t('components.basket_event_name.label')">
      <AtomInput :value="eventName" @keyup="(value) => (eventName = value)" />
    </SatFormControl>
  </div>
</template>

<style lang="scss" scoped>
.basket-event-name {
  position: relative;
}
</style>
